<template>
  <div class="feed">
    <div v-if="$mq !== 'mobile'"
         class="feed-title">
      {{ $t("feed.header") }}
    </div>
    <VuePerfectScrollbar ref="ps"
                         class="scroll-area"
                         @ps-scroll-y="scroll"
                         @ps-y-reach-end="load">
      <ul class="feed-items"
          ref="feedItems">
        <li v-for="(item, key) in filteredFeed"
            :key="key"
            class="feed-item">
          <component :is="getItemComponent(item.item_type)"
                     :item="item" />
        </li>
      </ul>
    </VuePerfectScrollbar>

    <feed-new-items-badge v-show="showNewItemsBadge"
                          :number="newItems.length"
                          @click="onNewItemsBadgeClick" />
  </div>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import FeedNewItemsBadge from './FeedNewItemsBadge.vue'
  import analytics from '@/services/analytics.js'

  const lookup = {
    applications_usage:    require('./Items/ItemAppUsage.vue').default,
    search:                require('./Items/ItemSearch.vue').default,
    block:                 require('./Items/ItemBlock.vue').default,
    warn:                  require('./Items/ItemWarn.vue').default,
    install:               require('./Items/ItemInstall.vue').default,
    screentime_exhausted:  require('./Items/ItemScreenTimeExhausted').default,
    child_app_install:     require('./Items/ItemChildAppInstall').default,
    advice:                require('./Items/ItemAdvice.vue').default,
    'location/geofence':   require('./Items/ItemGeofence.vue').default,
    request_access:        require('./Items/ItemRequest.vue').default
  }

  export default {
    components: {
      VuePerfectScrollbar,
      FeedNewItemsBadge
    },

    methods: {
      getItemComponent(type) {
        return lookup[type]
      },

      load: _.debounce(function() {
        this.loadFeed({
          scan_direction_forward: false
        })
      }, 100),

      scroll() {
        analytics.sendEvent('Scr_Feed')
      },

      onNewItemsBadgeClick() {
        this.prependNewItems()

        this.$scrollTo(this.$refs.feedItems, -1, {
          container: this.$refs.ps.$el,
        })
      },

      ...mapActions('feed', {
        loadFeed: 'load',
        loadNewItems: 'loadNewItems'
      }),

      ...mapMutations('feed', [
        'prependNewItems'
      ])
    },

    computed: {
      // Only some of items types are handled by front-end
      filteredFeed() {
        return this.filteredFeedByGeofence.filter(item => {
          return lookup[item.item_type]
        })
      },

      filteredFeedByGeofence() {
        return this.modifiedItemUser.filter(item => {
          if (item.item_type === 'location/geofence') {
            return this.namedLocationsIds.includes(Number(item.details.named_location_id))
          }

          return item
        })
      },

      modifiedItemUser() {
        return this.feed.map(item => {
          return {
            ...item,
            user: this.getChildById(item.user_id)
          }
        })
      },

      showNewItemsBadge() {
        return this.newItems.length > 0
      },

      ...mapGetters('feed', {
        feed: 'get',
        newItems: 'getNewItems'
      }),

      ...mapGetters('children', {
        getChildById: 'getById'
      }),

      ...mapGetters('geofence', {
        namedLocations: 'getNamedLocations'
      }),

      ...mapGetters('app', {
        visibilityState: 'getVisibilityState',
        isUserInactive: 'isUserInactive'
      }),

      namedLocationsIds() {
        return this.namedLocations.map(location => location.id)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .feed {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .feed-title {
    position: absolute;
    display: flex;
    align-items: center;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 60px;
    font-size: 18px;
    font-weight: bold;
    color: map_get($colors, primary);
    background-image: linear-gradient(to bottom, #ffffff, #ffffff 80%, rgba(255, 255, 255, 0.1));
  }

  .scroll-area {
    position: relative;
    height: 100%;
    margin-top: 50px;
  }

  .feed-items {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .feed-item {
    padding: 14px 14px 14px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  /deep/ .item-standart {
    display: flex;
    align-items: flex-start;

    .content {
      flex: 1 0;
      margin-left: 10px;
      overflow: hidden;
    }

    .description {
      font-size: 16px;
      line-height: 16px;
      color: #3e3a3b;
    }

    .details {
      opacity: 0.5;
      font-size: 14px;
      line-height: 14px;
      color: #3e3a3b;
      margin-top: 4px;
    }
  }
</style>
